import ToTopPresenter from "../components/to-top/presenter/to-top.js";

const thresholdElement = document.querySelector(`header`);

const toTopComponent = new ToTopPresenter(thresholdElement);
toTopComponent.init();
